<div class="full-page bg-primary container-fluid w-100">
  <div class="row">
    <div class="col-12">
      <div class="panel rounded overflow-hidden p-0">
        <div class="row">
          <div class="col-lg-5 d-none d-lg-block login-banner">
            <div class="apple-google-logos d-none d-lg-block w-100 mx-auto">
              <div class="font-size-16 font-weight-bolder mb-2 text-white">DOWNLOAD CLUB APP</div>
              <a class="mx-1" href="https://apps.apple.com/gb/app/mlb-ballpark/id513135722" target="_blank"
                ><img src="assets/images/login-registration/apple-link-logo.png"
              /></a>
              <a
                class="mx-1"
                href="https://play.google.com/store/apps/details?id=com.bamnetworks.mobile.android.ballpark&hl=en_GB"
                target="_blank"
                ><img src="assets/images/login-registration/google-link-logo.png"
              /></a>
            </div>
          </div>
          <div class="user-login-panel col-lg-7 col-12 text-left bg-white">
            <div class="container h-100">
              <div class="row h-100">
                <div class="col-12">
                  <router-outlet></router-outlet>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="font-size-16 font-weight-bolder text-center mb-2 text-white d-block d-lg-none">DOWNLOAD CLUB APP</div>
      <div class="apple-google-logos d-flex justify-content-center d-lg-none">
        <a href="https://apps.apple.com/gb/app/mlb-ballpark/id513135722" target="_blank"
          ><img src="assets/images/login-registration/apple-link-logo.png"
        /></a>
        <a href="https://play.google.com/store/apps/details?id=com.bamnetworks.mobile.android.ballpark&hl=en_GB" target="_blank"
          ><img src="assets/images/login-registration/google-link-logo.png"
        /></a>
      </div>
    </div>
  </div>
</div>
